import template from './needALoanModal.html';
import controller from './needALoanModal.controller';
import './needALoanModal.scss';

let needALoanModalComponent = {
  restrict: 'E',
  bindings: {
    cannotSignUpError: '<',
    messageError: '<',
    onDismiss: '&',
    isMobileApp: '<',
  },
  template,
  controller
};

export default needALoanModalComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/needALoanModal/needALoanModal.component.js